import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import getters from './getters'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'SDMCLOUD-STORE-VUEX'
})

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js